export const Locales: string[] = ['en', 'vi'];
